import axios from "axios";

// True during the react-snap prerender pass. Used to suppress network calls so
// prerendering doesn't emit ERR_FAILED for backend requests.
const IS_SNAPSHOT = typeof navigator !== "undefined" && /ReactSnap/.test(navigator.userAgent);

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

api.interceptors.request.use((config) => {
  if (IS_SNAPSHOT) {
    // Abort every request during prerender — no backend is reachable and the
    // resulting failures pollute the snapshot logs. Callers handle the reject.
    throw new axios.Cancel("ReactSnap: network disabled during prerender");
  }
  const token = localStorage.getItem("ppi_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
